export default __webpack_public_path__ + "static/media/honor-technical.d526d4a4.jpg";